import { Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    title: string,
    message: string,
    onOk: () => void
}

const Message = (props: IProps) => {
    return (
        <Modal backdrop='static' bsSize='lg' show={props.show} onHide={props.onOk}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.message}
            </Modal.Body>
            <Modal.Footer >
                <button className='btn btn-primary' onClick={props.onOk}>Ok</button>
            </Modal.Footer>
        </Modal>
    )
}

export default Message;